import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-count-menu',
  templateUrl: './stock-count-menu.component.html',
  styleUrls: ['./stock-count-menu.component.css']
})
export class StockCountMenuComponent implements OnInit {
    stockCountKeyno;

    public menu?: Menu;

    public approving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockCountKeyno = this.stateService.getStateParams()['stockcount_keyno'];
    }

    private async loadMenu() {
        if (!!this.stockCountKeyno) {
            this.menu = (await this.datatask.Post(952, { stockcount_keyno: this.stockCountKeyno }))[0];
        }
    }

    public async approveChanges() {
        if (!!this.menu) {
            try {
                this.approving = true;

                await this.datatask.Post(962, this.menu);

                this.loadMenu();
            } finally {
                this.approving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    //const response = (await this.datatask.Post(955, this.menu))[0];
                    await this.datatask.Post(955, this.menu);

                    //if (response.errorcode !== '0') {
                    //    this.modal.show({
                    //        type: 'warning',
                    //        title: 'error',
                    //        message: response.errormessage
                    //    });
                    //} else {
                        this.stateService.back();
                    //}
                }
            } finally {
                this.deleting = false;
            }
        }
    }
    
    public goToFunc(state: any) {
        switch (state) {
            case 'dataMining':
                this.datatask.Post(958, this.menu).then((response) => this.stateService?.go(response[0].item_state, response[0].item_parms));
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    stockcount_keyno: string;
    stockplace_name: string;
    approved: string;
    stockcount_date: string;
    approved_date: string;
    stockcount_name: string;
    show_setting: string;
    reg_by_portal_user_name: string;
    approved_by_portal_user_name: string;
    stockplace_id: string;
    stockcount_status: string;
    nbr_of_stockcounts: string;
    badgeinfo: string;
    floating_location: string;
}
